var $0e3cc9a288289dc5$exports = {};
$0e3cc9a288289dc5$exports = {
    "Empty": `\u{BE44}\u{C5B4} \u{C788}\u{C74C}`
};


export {$0e3cc9a288289dc5$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
